export const GET_UPLOAD_SIGNED_URL = 'GET_UPLOAD_SIGNED_URL';
export const GET_SIGNED_URL = 'GET_SIGNED_URL';
export const START_SIMPLE_S3_UPLOAD = 'START_SIMPLE_S3_UPLOAD';
export const SIMPLE_S3_PROGRESS = 'SIMPLE_S3_PROGRESS';
export const SIMPLE_S3_DONE = 'SIMPLE_S3_DONE';
export const SIMPLE_S3_FAILED = 'SIMPLE_S3_FAILED';